import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
    return (
        <div>
            <div className="navbar bg-base-100 shadow-md px-10">
                <div className="flex-1">
                    <NavLink to='/' className="btn btn-ghost normal-case text-xl">Learning Time</NavLink>
                </div>
                <div className="flex-none">
                    <ul className="menu menu-horizontal p-0">
                        <li><NavLink to='/topics'>Topics</NavLink></li>
                        <li><NavLink to='/statistics'>Statistics</NavLink></li>
                        <li><NavLink to='/blogs'>Blogs</NavLink></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Header;